export class ChoiceOptions {
  constructor(
    public firstOption: string,
    public secondOption: string
  ) {}
}
